import { api } from "@/redux/api";

import { ContactUsSchema, ContactUsType } from "../../pages/Home/schema/contact";

export const contactApi = api.injectEndpoints({
	endpoints: (builder) => ({
		requestContact: builder.mutation<ContactUsType, ContactUsType>({
			query: (body) => ({
				url: `mail/contact`,
				method: "POST",
				body,
				responseSchema: ContactUsSchema,
			}),
		}),
	}),
});

export const { useRequestContactMutation } = contactApi;
export const accountApiReducer = contactApi.reducer;
export const accountApiMiddleware = contactApi.middleware;
